import { render, staticRenderFns } from "./CompetencyDetailSkeleton.vue?vue&type=template&id=53570623&scoped=true"
import script from "./CompetencyDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./CompetencyDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDetailSkeleton.vue?vue&type=style&index=0&id=53570623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53570623",
  null
  
)

export default component.exports